export const piletConfig = {
  feedUrl: `${process.env.API_BASE_URL}/GetPiletConfigurations`,
};
